import {Component} from "react";
import Navbar from "../navbar";
import React from "react";


class KayHeader extends Component {
    toogleWidth = 1310;
    isMobileLayout = false;

    constructor(props) {
        super(props);
        this.state = {searchString: ''};
        this.onSearchInputChange = this.onSearchInputChange.bind(this);
    }

    onSearchInputChange(event) {
        this.setState({searchString: event.target.value});
    }

    onSearchClick(event) {
        event.preventDefault();
        document.getElementById('searchForm').submit()
    }

    render() {
        let styleHidden = {}
        let styleBar = ' showbar'
        this.isMobileLayout = window.innerWidth < this.toogleWidth;
        if (this.isMobileLayout) {
            styleHidden = {display: 'none'};
            styleBar = ''
        }
        return (
            <div className="kay">
                <div className="top-page-util-bar__wrapper" style={styleHidden}>
                    <div className="top-page-util-bar row">
                        <div className="ui-lg-12">
                            <div className="top-page-util-bar__right">
                                <ul>
                                <li className="util-dropdown" id="instantCreditId"><a style={{width:'auto'}} 
                                        href={window.baseSiteUrl + "/favorites"}>
                                        Favorites&nbsp;<i className="fa fa-heart" ></i>
                                    </a></li>
                                
                                    <li><a style={{width:'auto'}} 
                                        href={window.baseSiteUrl + "/store-finder"}>
                                        Find a Store&nbsp;<i className="fa fa-map-marker"></i></a>
                                    </li>
                                    <li  id="instantCreditId">
                                        <a style={{width:'auto'}} href={window.baseSiteUrl + "/credit-landing"}>KAY Credit Card&nbsp;</a><i className="fa fa-credit-card"></i></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="site-header-wrapper">
                    <header  className={"site-header row" + !this.isMobileLayout ? "" : " mobile"} >
             
                        
                        {/* <div className="site-header__mobile-btns site-header__mobile-btns--right" style={styleHidden}>
                         <div>
                        <form id="searchForm"
                                  action={window.baseSiteUrl + "/search/" }>
                                <div id="searchBar" className="desktop-header-search" style={{display: 'block'}}>
                                    <div className="gb-kay-sayt gb-ui">
                                        
                                        
                                    </div>
                                </div>
                            </form>
                            </div>   
                           
                            <a href={window.baseSiteUrl + "/cart"}
                               className="site-header__button--bag" id="shoppingCartBar">
                               
                            </a>
                        </div> */}
                         
                         {/* <div style={{width:'100%', textAlign:'center', marginBottom:5, display:'flex', alignItems:'center'}} ><div className="nav-section nav-left"></div><div className="nav-section nav-center"></div>
                         <div className="nav-section nav-right"></div></div> */}
                        
                        <div className={"header-container"/* +styleBar */}>
                        {!this.isMobileLayout &&<a href="https://www.kay.com/?icid=LOGO" style={{width:'auto',position:'absolute',left:25,zIndex:1000}}><img className='logokay' style={{height:'16px'}} src="https://images-aka.kay.com/ico/kay-logo.svg"/></a>}
                        <Navbar model={this.props.model} toogleWidth={this.toogleWidth}>
                            
                            {this.isMobileLayout &&
                            <div style={{display: 'flex'}}>
                                <div style={{textAlign: 'center', width: '100%'}}>
                                    <a className="logo" href={window.baseSiteUrl} title="Kay Jewelers"><img className='logokay' style={{height:'20px', position:'static', marginLeft: 0, marginTop: 10}} src="https://images-aka.kay.com/ico/kay-logo.svg"/></a>
                                </div>
                                <div style={{minWidth: '50px'}}>
                                    <div className="site-header__mobile-btns site-header__mobile-btns--right" style={{marginTop:25}}>
                                       
                                        <a href={window.baseSiteUrl + "/cart"} 
                                           className="site-header__button--bag" id="shoppingCartBar">
                                        </a>
                                    </div>
                                </div>
                            </div>
                            }
                        </Navbar>
                        {!this.isMobileLayout &&<a href={window.baseSiteUrl + "/cart"} id="shoppingCartBar" style={{position:'absolute',width:'auto',right:25,zIndex:1000}} ><img className='' style={{}} src="https://www.kay.com/scripts/assets/common/images/signetrd-icons/bag-2.svg"/></a>}
                        </div>
                         
                    </header>
                </div>
            </div>
        )
    }
}

export default KayHeader;


// WEBPACK FOOTER //
// ./src/site_interfaces/headers/kay.js